import { NextSeo } from "next-seo";
import { Navbar } from "~/components/Navbar/component";
import { Routes } from "~/routes";
import { PageTrack } from "~/modules/analytics/components/PageTrack";
import { PageWrapper, SidebarLayout } from "~/components/SidebarLayout";
import { SearchPage } from "~/modules/search/pages/search";
import { UserFetcher } from "~/modules/user/components/UserFetcher";
import { addBaseUrl } from "~/modules/app/seo/addBaseUrl";
import { BreadcrumbSEO } from "~/modules/app/seo/BreadcrumbSEO";

// // // //

export default function Search() {
    return (
        <PageTrack route={Routes.search}>
            <NextSeo
                canonical={addBaseUrl(Routes.search)}
                title="Search"
                description="Search and browse all available pages and features on RWA.xyz"
            />
            <BreadcrumbSEO
                items={[
                    {
                        name: "Search",
                        href: Routes.search,
                    },
                ]}
            />
            <UserFetcher>
                {({ user }) => <Navbar route={Routes.search} user={user} />}
            </UserFetcher>

            <SidebarLayout pathname={Routes.search}>
                <PageWrapper>
                    <SearchPage />
                </PageWrapper>
            </SidebarLayout>
        </PageTrack>
    );
}
